import { useCallback, useEffect, useRef } from 'react';

const VERSION_CHECK_INTERVAL = 300_000; // 5 minut

interface VersionInfo {
  buildHash: string;
  buildTime: string;
  version: string;
}

export function useVersionCheck(): void {
  const initialHashRef = useRef<string | null>(null);
  const isReloadingRef = useRef(false);

  const checkVersion = useCallback(async () => {
    if (isReloadingRef.current) return;

    try {
      const response = await fetch(`/version.json?_t=${Date.now()}`, {
        cache: 'no-store',
      });

      if (!response.ok) return;

      const data: VersionInfo = await response.json();

      if (initialHashRef.current === null) {
        initialHashRef.current = data.buildHash;
        return;
      }

      if (data.buildHash !== initialHashRef.current) {
        console.log(
          `[VersionCheck] Nova verze: ${initialHashRef.current} -> ${data.buildHash}. Reload...`,
        );
        isReloadingRef.current = true;

        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((name) => caches.delete(name)));
        }

        window.location.reload();
      }
    } catch {
      // Sitova chyba — tise ignoruj, zkusi se znovu za interval
    }
  }, []);

  useEffect(() => {
    checkVersion();
    const intervalId = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
    return () => clearInterval(intervalId);
  }, [checkVersion]);
}
